<template>
  <div>
    <ul>
      <slot name="li">

      </slot>
    </ul>
  </div>
</template>

<script>
export default {
  name: "DropDownItem",

  methods: {

    handleClick(index) {
      console.log("aaa", index)
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DropDownItem.vue